import { Component, OnInit } from '@angular/core';
import { environment }                from '../environments/environment';

@Component({
  selector: 'app-footer',
  template: `      
  <div class="col-xs-12" style="margin:1px;text-align:right; font-size: 0.7em; padding-left: 2px; padding-right: 4px">
  <hr class="col-xs-12 graythinborder">
  <div class="col-xs-3">
    <!--<a href="https://onreference.com/privacy.html">Privacy Policy </a>-->
  </div>  
  <div class="col-xs-9">
  Copyright © 2021 <a href="https://onreference.com">OnReference.</a> All Rights Reserved. v{{version}}
  </div>
  </div>
  `,
  styleUrls: []
})
export class FooterComponent implements OnInit {
  version = environment.version;

  constructor() { }

  ngOnInit() {
  }

}
